/*
 * Why Langley cards: Embla handles drag, snap, and end containment.
 * Dots follow Embla snap points and stay hidden when everything fits.
 */

import EmblaCarousel from 'embla-carousel'

const SELECTOR = '[data-why-carousel]'

function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function setup(root) {
	const viewport = root.querySelector('.why-carousel__viewport')
	const dotsWrap = root.querySelector('.why-carousel__dots')
	const cards = Array.from(root.querySelectorAll('.why-card'))

	if (!viewport || cards.length < 2) return

	const embla = EmblaCarousel(viewport, {
		align: 'start',
		containScroll: 'trimSnaps',
		dragFree: false,
		skipSnaps: false,
		duration: prefersReducedMotion() ? 0 : 22,
		watchDrag: (api) => api.canScrollPrev() || api.canScrollNext(),
	})

	const isScrollable = () => embla.canScrollPrev() || embla.canScrollNext()

	const syncChrome = () => {
		const scrollable = isScrollable()
		root.classList.toggle('is-scrollable', scrollable)
		viewport.tabIndex = scrollable ? 0 : -1

		if (scrollable) {
			viewport.setAttribute('aria-label', root.dataset.label || 'Cards')
		} else {
			viewport.removeAttribute('aria-label')
		}

		if (!dotsWrap) return

		const snaps = embla.scrollSnapList()
		const selected = embla.selectedScrollSnap()

		if (dotsWrap.childElementCount !== snaps.length) {
			dotsWrap.replaceChildren()
			snaps.forEach((_, index) => {
				const dot = document.createElement('button')
				dot.type = 'button'
				dot.className = 'why-carousel__dot'
				dot.setAttribute('aria-label', `Go to group ${index + 1}`)
				dot.addEventListener('click', () => embla.scrollTo(index))
				dotsWrap.appendChild(dot)
			})
		}

		Array.from(dotsWrap.children).forEach((dot, index) => {
			if (index === selected) {
				dot.setAttribute('aria-current', 'true')
			} else {
				dot.removeAttribute('aria-current')
			}
		})
	}

	viewport.addEventListener('keydown', (event) => {
		if (!isScrollable()) return
		if (event.key === 'ArrowRight') {
			event.preventDefault()
			embla.scrollNext()
		}
		if (event.key === 'ArrowLeft') {
			event.preventDefault()
			embla.scrollPrev()
		}
	})

	embla.on('pointerDown', () => root.classList.add('is-dragging'))
	embla.on('pointerUp', () => root.classList.remove('is-dragging'))
	embla.on('select', syncChrome)
	embla.on('reInit', syncChrome)
	syncChrome()
}

export default function initWhyCarousel() {
	document.querySelectorAll(SELECTOR).forEach(setup)
}
